import { TranslationObject } from '../i18n/translation';

const namespace = 'evaluation/evaluationTabs';

const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Vurdering i',
    en: 'Evaluation for',
  },
  loading_title: {
    id: `${namespace}.loading_title`,
    nb: 'Laster vurdering...',
    en: 'Loading evaluation...',
  },
  learning_goals: {
    id: `${namespace}.learning_goals`,
    nb: 'Læringsutbytte',
    en: 'Learning goals',
  },
  daily_evaluation: {
    id: `${namespace}.daily_evaluation`,
    nb: 'Daglig vurdering',
    en: 'Daily evaluation',
  },
  mid_term_evaluation: {
    id: `${namespace}.mid_term_evaluation`,
    nb: 'Midtveisvurdering',
    en: 'Mid-term evaluation',
  },
  final_evaluation: {
    id: `${namespace}.final_evaluation`,
    nb: 'Sluttvurdering',
    en: 'Final evaluation',
  },
  absence: {
    id: `${namespace}.absence`,
    nb: 'Fravær',
    en: 'Absence',
  },
  confirmation: {
    id: `${namespace}.confirmation`,
    nb: 'Bekreftelse',
    en: 'Confirmation',
  },
  back: {
    id: `${namespace}.back`,
    nb: 'Til praksisaktiviter for vurdering',
    en: 'To practice activities for evaluation',
  },
};

export default translations;
